import * as yup from 'yup';
import { IV_DRIP_CATEGORY_ID } from '@/views/Pages/Product/AddEditProduct/AddEditProduct';

// Custom transformer to change empty strings to null
/*
const toNullTransform = (value, originalValue) => {
  return originalValue === '' ? null : value;
};
*/

const creditGrantSchema = yup.object({
  credit_type: yup.string().required('Credit type is required'),
  num_to_grant: yup
    .number()
    .required('Credits to Grant is required')
    .min(0, 'Credits to Grant must be a non-negative number')
    .typeError('Credits to Grant must be a number'),
  expires_days: yup
    .number()
    .required('Days to Expire is required')
    .min(0, 'Days to Expire must be a non-negative number')
    .typeError('Days to Expire must be a number')
});

export const PurchasableItemSchema = yup.object().shape({
  id: yup
    .number()
    .positive('ID must be a positive number')
    .required("Please select item's ID")
    .typeError('ID must be a number'),
  purchase_category: yup.string().when('type', {
    is: 'membership',
    then: yup.string().notRequired(),
    otherwise: yup
      .string()
      .required('Please select the category')
      .typeError('Please select the category!')
  }),
  short_description: yup
    .string()
    .required('Please add a short description')
    .typeError('Please add a short description'),
  description: yup
    .string()
    .required('Please add a description')
    .typeError('Please add a description'),
  drip_ingredients: yup.array().when(['purchase_category', 'type'], {
    is: (purchase_category, type) =>
      purchase_category == IV_DRIP_CATEGORY_ID && type == 'product',
    then: yup.array().of(
      yup.object().shape({
        ingredient: yup
          .string()
          .required('Nutrient is required')
          .notOneOf([''], 'Nutrient cannot be empty'),
        quantity: yup
          .number()
          .min(1, 'Quantity must be at least 1')
          .typeError('Please define quantity')
      })
    ),
    otherwise: yup.array().nullable().notRequired()
  }),
  item_price: yup.array().of(
    yup
      .object()
      .nullable()
      .shape({
        member_price: yup
          .number()
          .transform((value, originalValue) => {
            // Transforming an empty string into null
            return originalValue === '' ? null : value;
          })
          .min(0, 'Member price cannot be negative')
          .typeError('Select member Price')
          .nullable(),
        non_member_price: yup
          .number()
          .min(0, 'Non member price cannot be negative')
          .typeError('Select non member price')
          .nullable()
      })
  ),
  duration: yup
    .number()
    .nullable()
    .notRequired()
    .min(0, 'Duration must be a non-negative number')
    .typeError('Duration must be a number'),
  padding_before_virgin: yup
    .number()
    .nullable()
    .notRequired()
    .min(0, 'Padding Before Virgin must be a non-negative number')
    .typeError('Padding Before Virgin must be a number'),
  padding_before: yup
    .number()
    .nullable()
    .notRequired()
    .min(0, 'Padding Before must be a non-negative number')
    .typeError('Padding Before must be a number'),
  padding_after: yup
    .number()
    .nullable()
    .notRequired()
    .min(0, 'Padding After must be a non-negative number')
    .typeError('Padding After must be a number'),
  membership_type: yup.object().shape({
    expires_months: yup
      .number()
      .nullable()
      .notRequired()
      .min(0, 'Expires months must be a non-negative number')
      .typeError('Expires months must be a number'),
    credits_on_pay: yup
      .number()
      .nullable()
      .notRequired()
      .min(0, 'Credits on Pay must be a non-negative number')
      .typeError('Credits on Pay must be a number'),
    credits_daily: yup
      .number()
      .nullable()
      .notRequired()
      .min(0, 'Credits Daily must be a non-negative number')
      .typeError('Credits Daily must be a number'),
    founder_discount: yup
      .number()
      .nullable()
      .notRequired()
      .min(0, 'Founder Discount must be a non-negative number')
      .typeError('Founder Discount must be a number'),
    display_order: yup
      .number()
      .nullable()
      .notRequired()
      .min(0, 'Display Order must be a non-negative number')
      .typeError('Display Order must be a number'),
    display_group: yup
      .number()
      .nullable()
      .notRequired()
      .min(0, 'Display Order must be a non-negative number')
      .typeError('Display Order must be a number'),
    billing_frequency: yup
      .string()
      .nullable()
      .oneOf(
        [null, 'monthly', 'daily'],
        'Billing frequency must be either "monthly" or "daily"'
      )
      .notRequired()
  }),
  credit_grants: yup
    .array()
    .of(creditGrantSchema)
    .when('type', (type, schema) => {
      switch (type) {
        case 'product':
          return yup.array().notRequired(); // Not required for 'product'
        case 'membership':
          return yup.array().of(creditGrantSchema).min(0); // Optional but validated if provided
        case 'bundle':
          return schema
            .required('Credit grants are required for bundles')
            .min(1, 'At least one credit grant is required for bundles');
        default:
          return schema; // Default behavior
      }
    }),
  is_always_Available: yup.boolean().nullable(true),
  is_active: yup.boolean().nullable(true),
  is_medical: yup.boolean().nullable(true),
  isunlimited: yup.boolean().nullable(true),
  is_super: yup.boolean().nullable(true),
  taxable: yup.boolean().nullable(true),
  excluded_rolls_into: yup
    .string()
    .matches(
      /^\d+(,\s*\d+)*$/,
      'Invalid membership exclusion format. Please enter numbers separated by commas.'
    )
});
